var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/~/core-js/internals/try-to-string.js
// module id = 919
// module chunks = 0